// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U6y4","colBig":"styles_colBig__1beWF","colSmall":"styles_colSmall__1F-tk"};